<template>
  <h2>About CAAMS</h2>
  <div class="divParent">
    <div class="divText">
      <p tabindex="0">
      CAAMS - the Civilian Arming Authorization Management System - has been used to manage the arming authorization
      process for DoD contractor personnel in Afghanistan since January 1, 2015, and was mandated for use CENTCOM-wide 
      September 1, 2021.
      </p>
      <p class="largerHeader">
        CAAMS users fall into one of three categories:
      </p>

      <p class="indentParagraph"><strong>Vendor:</strong> A company (contractor) representative tasked to provide/upload all documentation in support
        of a request to arm DoD contractor personnel.</p>

      <p class="indentParagraph"><strong>Contracting Officer (KO):</strong> A USG representative responsible for managing all aspects of a DoD
        contract. Often KOs are responsible for multiple contracts across multiple locations.</p>

      <p class="indentParagraph"> <strong>Contracting Officer's Representative (COR):</strong> A USG representative who maintains local oversight of DoD contractor
        personnel. The COR's responsibility in the arming process is to review the documentation provided by the Vendor to
        ensure accuracy. Once each individual contractor's documentation has been reviewed, or Quality Checked (QC'd), the COR
        marks the package as Complete. <strong>Note:</strong> This last step is accomplished by clicking the “ Complete” button for each
        individual, once all documentation has been reviewed, and all deficiencies corrected.</p>

      <p class="indentParagraphLarge"><strong>Note:</strong> The COR also represents the Requesting Official (RO). The RO is the USG representative who makes the
        determination that DoD contractor personnel need to be armed, based on the current threat environment, force
        protection condition, operational environment, etc. If required by policy, the RO submits a written request to arm the
        DoD contractor personnel. This request is referred to as the “RO memo” and is made to the arming authority. In
        practice, a company representative will typically draft the RO memo and route it to the COR for review. The COR will
        then route the RO memo to an appropriate signature authority.</p>

        <!--<p tabindex="0" class="indentParagraphLarge"><strong>To learn more:</strong> Please download the <span class="blueLink">Arming Authorization Process</span>.</p>-->

        <p class="largerHeader">Brief overview of the arming authorization process:</p>

        <ol class="indentParagraph">

          <li>Vendor creates an entry in CAAMS for each DoD contractor employee who needs to be armed and fills in all required information (“Add Person” from Contractor menu).</li>
          <li class="liMarginTop">
              Vendor compiles all documentation required for each arming request and uploads to CAAMS for each DoD contractor employee who needs to be armed. Complete documentation consists of:

              <ul>
                  <li class="liMarginTop">Synchronized Pre-deployment and Operational Tracker Letter of Authorization (SPOT LOA).</li>
                  <li class="liMarginTop">Background check memorandum or Qualification to Possess Firearms or Ammunition (DD Form 2760).</li>
                  <li tabindex="0" class="liMarginTop">Weapons Scorecards (Pistol, Rifle, other as applicable) or host nation weapon permit.</li>
                  <li style="margin-left: 15px; list-style: none; margin-top: 15px; margin-bottom: 15px;"><strong style="font-size: 18px;">Note:</strong> Vendors should ensure that they upload each document to the correct slot in CAAMS. For non-U.S. citizens, the COR must also upload a Biometric Verification (BV) letter for each DoD contractor employee.</li>
                  <li>COR reviews (QC's) all documents for each individual in CAAMS for completeness and accuracy. If inaccuracies are found, the COR should make a note of what needs to be corrected and return the package to the Vendor (place in the HOLD queue).</li>
                  <li class="liMarginTop">If all documentation in the package is accurate, the COR should click the Complete button for each individual.</li>
              </ul>
          </li>

        </ol>

    </div>
  </div>
</template>

<script>
export default {
  data() {return{};},
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped>

.divParent {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 30px;
}

.divText {
  text-align: left;
  width: 80%;
}

.underlineText {
  text-decoration: underline;
}

.largerHeader {
  font-size: 20px;
}

.blueLink {
  color: rgb(60, 104, 176);
  text-decoration: underline;
}

.indentParagraph {
  margin-left: 30px;
}

.indentParagraphLarge {
  margin-left: 60px;
}

 .liMarginTop {
  margin-top: 5px;
 }

</style>
